
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Paragraph } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Paragraph size="lead" mdxType="Paragraph">
  Media utilities let you alter media display (images, videos, ...). It allows
  you to change the size, ratio, and image fill beahvior.
    </Paragraph>
    <p><strong parentName="p">{`Important:`}</strong>{` Depending on the clases used, image may be distorded or not correctly displayed (see examples).
So these utilities have to be used wisely.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;